export function getAbsoluteRoute(route: string): string {
	return route.startsWith('/') ? route : `/${route}`;
}
